import { DASHBOARD_TYPE } from '@utils/constants';

const DASHBOARD_NAME = {
  [DASHBOARD_TYPE.COMPARE]: 'Compare',
  [DASHBOARD_TYPE.ERROR_DIAGNOSTICS]: 'Error Analysis',
  [DASHBOARD_TYPE.TIMELINE]: 'Timeline',
  [DASHBOARD_TYPE.NOC]: 'Real-Time',
  [DASHBOARD_TYPE.ML]: 'Metriclens',
  [DASHBOARD_TYPE.OVB]: 'Overview',
};


/**
 * TODO
 * @param {string} dashboardName
 * @param {enum} value of DASHBOARD_TYPE
 * @description will refactor when the compare use temp store
 */
const combineDashboardName = (dashboardName, dashboardType) => {
  if (dashboardType === DASHBOARD_TYPE.ALERT_DIAGNOSTICS) {
    return dashboardName;
  }
  return typeof dashboardName === 'string'
    ? dashboardName.split(' ').reduce(
      (name, str) => {
        if (str === 'New') {
          return `${DASHBOARD_NAME[dashboardType]}`;
        }
        return `${name} ${str}`;
      },
      '',
    ) : '';
};

export default combineDashboardName;
